export default __webpack_public_path__ + "static/media/Claws of Savagery.6b4c20eb.png";